<app-titled-page heading="Grupos">
  <router-outlet></router-outlet>
</app-titled-page>
